<template>
	<div class="flow-form-field-row">
		<slot />
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "FormFieldRow"
});
</script>
<style lang="scss">
div.flow-form-field-row {
	display: flex;

	> * {
		margin-right: 16px;

		&:last-child {
			margin-right: 0px;
		}
	}
}
</style>
